import { useRef, useState } from 'react';

const useImageCarousel = (tmntData, handleImageErrorOrRemoval, directionalArrowCodes = ['ArrowDown', 'ArrowUp']) => {
  const mountRef = useRef(null);
  const [visibleTabID, setVisibleTabID] = useState('slide-1');

  const setImageData = (imageData, index) => {
    const currentIndex = index + 1;
    const altKey = `${imageData.type}AltImageText`;
    const altText = tmntData[altKey]?.value;
    const imageTypeIndex = imageData.imgTypeIndex + 1;
    const newImageButton = {
      ariaControls: `slide-${currentIndex}`,
      id: `control-slide-${currentIndex}`,
      isSelected: visibleTabID === `slide-${currentIndex}`,
      key: imageData.thumbnailSrc,
      labelText: altText?.replace('{0}', imageTypeIndex),
      alt: altText?.replace('{0}', imageTypeIndex),
      onClick: (anEvent) => setVisibleTabID(anEvent.currentTarget.getAttribute('aria-controls')),
      onError: () => handleImageErrorOrRemoval(imageData.imageId),
      ref: mountRef,
      src: imageData.thumbnailSrc,
    };
    return newImageButton;
  };

  const onKeyDown = (imageButtons) => (anEvent) => {
    if (directionalArrowCodes.includes(anEvent.code)) {
      anEvent.preventDefault();
      const buttonIDs = imageButtons.map(({ ariaControls: id }) => id);
      const currentIndex = buttonIDs.indexOf(visibleTabID);

      const deltasByCode = {
        ArrowDown: 1,
        ArrowLeft: -1,
        ArrowRight: 1,
        ArrowUp: -1,
      };

      const indexOfSlideToShow = (
        imageButtons.length
        + currentIndex
        + deltasByCode[anEvent.code]
      ) % imageButtons.length;

      setVisibleTabID(buttonIDs[indexOfSlideToShow]);
      imageButtons[indexOfSlideToShow].ref.current.focus();
    }
  };

  return {
    setVisibleTabID,
    setImageData,
    onKeyDown,
    visibleTabID,
  };
};

export default useImageCarousel;
